import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { TemplateRecord } from '../types/templates.types';

export const templatesListService = {
  async getTemplates(companyId: string): Promise<TemplateRecord[]> {
    await enforceSettingsPermission('settings.templates.view', { companyId });
    
    const { data, error } = await supabase
      .from('settings_templates')
      .select('*')
      .eq('company_id', companyId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return (data || []).map(row => ({
      id: row.id,
      companyId: row.company_id,
      name: row.name,
      code: row.code,
      description: row.description,
      type: row.type,
      usageCount: row.usage_count,
      status: row.status,
      content: row.content,
      createdBy: row.created_by,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    }));
  },

  async deleteTemplate(id: string) {
    await enforceSettingsPermission('settings.templates.manage');
    const { error } = await supabase
      .from('settings_templates')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};
